import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import { Subscription, filter, merge, skip } from 'rxjs';
import { PatientManagerListService } from 'src/patient-manager/services/patient-manager-list.service';
import { PatientManagerTableDataSource } from './patient-manager-table-datasource';
import { PMDialogsManagerService } from 'src/patient-manager/services/pm-dialogs-manager.service';
import { NavigationStart, Router } from '@angular/router';
import { SortingHeadersEnum } from './enums/sorting-headers-enum';
import { SortingDirectionsEnum } from 'src/common-panel/enums/sorting-directions-enum';
import { UtilsService } from 'src/common-panel/services/utils.service';
import { PMPatientListItem } from 'src/patient-manager/common/models/internal/pm-patient-list-item.model';
import { PMShopItemJSON } from 'src/patient-manager/common/models/server-response/pm-shop-item-json.model';
import { ShopFilterStates } from './enums/shop-filter-states';
import { formatDate } from '@angular/common';

@Component({
    selector: 'app-patient-manager-table',
    templateUrl: './patient-manager-table.component.html',
    styleUrls: ['./patient-manager-table.component.css'],
    standalone: false
})
export class PatientManagerTableComponent
{

  subscription: Subscription = new Subscription()


  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;
  @ViewChild(MatTable) table?: MatTable<PatientManagerListService>;


  dataSource: PatientManagerTableDataSource
  shopList: PMShopItemJSON[] = this.patientManagerListService.shopsData

  displayedColumns = [
    "name",
    "patientId",
    "email",
    "shopId",
    "lastSeen",
    "dateOfRegistration",
    "actions",
  ];

  ShopFilterStates = ShopFilterStates
  formatDate=formatDate

  constructor(private dialogsManagerService: PMDialogsManagerService, private elementRef: ElementRef, private router: Router,
    private patientManagerListService: PatientManagerListService, private cref: ChangeDetectorRef, private utilsService: UtilsService)
  {
    this.dataSource = new PatientManagerTableDataSource(this.patientManagerListService);
  } //private userManageService: UserManageService,private clinicService: ClinicService, private entOfficeService: EntOfficeService

  ngAfterContentInit(): void
  {
    this.cref.detectChanges()
  }

  ngOnInit(): void
  {
    this.patientManagerListService._loadedShopsSubject.subscribe(l_loaded =>
    {
      if (l_loaded) this.shopList = this.patientManagerListService.shopsData.sort((val1, val2) => (val1.shopId > val2.shopId) ? 1 : -1)
    })

    this.patientManagerListService.filterByCountry.pipe(skip(1)).subscribe(() =>
    {
      this.setShopFilter(ShopFilterStates.all)
      this.dataSource.loadPatients();
    })

    let l_sub = this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(() =>
    {
      this.subscription.unsubscribe();
      l_sub.unsubscribe();
      this.dataSource.disconnect();
      this.elementRef.nativeElement.remove();
    });

    let l_sub2 = this.patientManagerListService.needsToRefresh.pipe(filter(l_val => l_val == true)).subscribe(() =>
    {
      this.refreshTable()
    })

    this.dataSource.loadPatients();

    this.subscription.add(l_sub2)
  }


  ngOnDestroy(): void
  {
    this.subscription.unsubscribe();
  }

  ngAfterViewInit()
  {
    let l_sub = this.sort!.sortChange.subscribe(() =>
    {
      this.paginator!.pageIndex = 0;
      this.dataSource.sortDirection = this.sort!.direction as SortingDirectionsEnum;
      this.dataSource.sortingHeader = this.sort!.active as SortingHeadersEnum;
      this.dataSource.sortData()
    });

    let l_sub2 = merge(this.sort!.sortChange, this.paginator!.page).subscribe(() =>
    {
      this.loadPatientsPage();
    });

    this.subscription.add(l_sub);
    this.subscription.add(l_sub2);
  }


  loadPatientsPage()
  {

    this.dataSource.pageSize = this.paginator!.pageSize;
    this.dataSource.pageIndex = this.paginator!.pageIndex;
    this.dataSource?.loadPatientsPage();
  }

  refreshTable()
  {
    this.dataSource?.loadPatients();
  }

  resetPassword(patientItem: PMPatientListItem)
  {
    this.patientManagerListService.currentPatient = patientItem;
    this.dialogsManagerService.showResetPasswordDialogComponent()
  }

  deletePatient(patientItem: PMPatientListItem)
  {
    this.patientManagerListService.currentPatient = patientItem;
    this.dialogsManagerService.showDeletePatientDialogComponent()
  }

  transferPatient(patientItem: PMPatientListItem)
  {
    this.patientManagerListService.currentPatient = patientItem;
    this.dialogsManagerService.showTransferPatientDialogComponent()
  }

  getRelativeDateTimeWithDaysMonthAgo(date: string): string
  {
    return this.utilsService.getRelativeDateTimeWithDaysMonthAgo(date)
  }

  getShownShop(): string
  {
    switch (this.patientManagerListService.tableSettings.shopFilterState)
    {
      case ShopFilterStates.all:
        return "All Shops";

      case ShopFilterStates.oneShop:
        return 'Only ' + this.patientManagerListService.tableSettings.currentFilterShop?.shopId;
    }
  }


  setShopFilter(filter: ShopFilterStates, shop?: PMShopItemJSON): void
  {
    this.dataSource.shopFilter = { state: filter, shop: shop };
    this.dataSource.filterData();
    this.dataSource.sortData();
    if (this.paginator) this.paginator!.pageIndex = 0;
    this.loadPatientsPage();
  }

}
